import { CommonLookupItem } from '@admin/shared/models/common-lookup-item.model';
import { Serializable } from '@admin/core/models/serializable';

export class SendInvoiceResultModel
  implements Serializable<SendInvoiceResultModel>
{
  fromObject(object: any): SendInvoiceResultModel {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public success: boolean;
  public displayMessage: string;
  public sent: boolean;
  public agents: CommonLookupItem<number, string>[];
}
